import { EntityType } from '@frontend/common';
import { accountIdFromResolvedEntity } from '@frontend/components/common';
import { defaultCellClassName } from '@frontend/components/list';
import { CommonMessage } from '@frontend/lang';
import { hasMixedColliLocations } from '@frontend/transaction/common';
import { ExtendedPudoTransaction } from '@frontend/transaction/types';
import { FormattedMessage } from 'react-intl';

import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { renderTransactionStatusCell } from '../transactions_collis/transaction-status-cell/transaction-status-cell.component';

export { renderTransactionStatusCell };

export const renderCollisCountCell = (obj: { row: { original: ExtendedPudoTransaction } }) => (
    <td className={defaultCellClassName}>{obj.row.original.collis?.length || 1}</td>
);

export const renderDestinationSlotCell = (obj: { row: { original: ExtendedPudoTransaction } }) => {
    const transaction = obj.row.original;

    if (hasMixedColliLocations(transaction.collis)) {
        return (
            <td
                key={`${transaction.id}-slot`}
                className={defaultCellClassName}>
                <span className='text-foreground-default text-sm font-medium'>
                    <FormattedMessage
                        id='platform.applications.pudo.awaiting.multiple-locations'
                        description='Shown in awaiting lists when parcels of a transaction are at different current locations'
                        defaultMessage='Multiple locations'
                    />
                </span>
            </td>
        );
    }

    return (
        <td
            key={transaction.slot?.entity_id}
            className={defaultCellClassName}>
            {transaction.slot ? (
                <PlatformObjectBadge
                    id={transaction.slot?.entity_id}
                    display={transaction.slot?.name}
                    entityType={EntityType.SLOT}
                    key={transaction.slot?.entity_id}
                    parentIds={{
                        spot_id: transaction.slot.data.spot_id,
                        module_id: transaction.slot.data.module_id
                    }}
                    foreign={transaction.slot?.foreign}
                    accountId={accountIdFromResolvedEntity(transaction.slot)}
                />
            ) : (
                <span>/</span>
            )}
        </td>
    );
};

export const awaitingDestinationHeaderOverwrite = {
    spot: CommonMessage.OBJECTS.TRANSACTION.DESTINATION,
    slot: CommonMessage.OBJECTS.SLOT.DESTINATION,
    collis: CommonMessage.OBJECTS.PARCEL.PLURAL,
    state: CommonMessage.OBJECTS.COMMON_FIELDS.STATUS
} as const;
